import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import SEOHead from '../../components/seo/SEOHead';
import { useState, useEffect, useMemo, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function Inventory() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const brandParam = searchParams.get('brand');
  
  const [selectedBrand, setSelectedBrand] = useState('全て');
  const [selectedCategory, setSelectedCategory] = useState('全て');
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [itemImageIndexes, setItemImageIndexes] = useState<{[key: string]: number}>({});

  // URLパラメータからブランドを設定し、ページトップにスクロール
  useEffect(() => {
    if (brandParam && ['PANDIESTA', 'SINACOVA', 'BARNI VARNO'].includes(brandParam)) {
      setSelectedBrand(brandParam);
    }
    // ページの最上部にスクロール
    window.scrollTo(0, 0);
  }, [brandParam]);

  const brands = ['全て', 'PANDIESTA', 'SINACOVA', 'BARNI VARNO'];
  const categories = ['全て', 'Tシャツ', 'シャツ', 'パンツ', 'ジャケット', 'アクセサリー'];

  const inventoryItems = [
    {
      id: 'item-1',
      name: 'エバンゲオンコラボジャンパー',
      brand: 'PANDIESTA',
      category: 'ジャケット',
      price: 39000,
      originalPrice: 43780,
      stock: 1,
      size: 'L',
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/80865ed698f961ee1c0a492837e84914.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/ed8f65cb12ec57271ebf585c8f2fa691.jfif'
      ]
    },
    {
      id: 'item-2',
      name: 'ジーンズ１',
      brand: 'PANDIESTA',
      category: 'パンツ',
      price: 14500,
      originalPrice: 16280,
      stock: 1,
      size: '34inch',
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/ee09c7265386ffabe129885122bc8741.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/f9313bb74139904003851b9e5334bc25.jfif'
      ]
    },
    {
      id: 'item-3',
      name: 'セーター１',
      brand: 'BARNI VARNO',
      category: 'ジャケット',
      price: 64900,
      stock: 1,
      size: 'L',
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/61d174ef248193f9e585249a8567b736.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/95f23f510e55de98257eaabcee85fc8a.jfif'
      ]
    },
    {
      id: 'item-4',
      name: 'ジーンズ2',
      brand: 'PANDIESTA',
      category: 'パンツ',
      price: 15500,
      originalPrice: 17380,
      stock: 1,
      size: '40inch',
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/492c7acef4f85588f41a07323af37a23.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/2594a3e1df220ed7860bd031a6768951.jfif'
      ]
    },
    {
      id: 'item-5',
      name: 'SINACOVAジャンパー',
      brand: 'SINACOVA',
      category: 'ジャケット',
      stock: 1,
      color: 'ネイビー×ブルー',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/c33ac1d065181a8b51e3c234e0da538f.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/31ad607c80395565e908ed8287d754e6.jfif'
      ]
    },
    {
      id: 'item-6',
      name: 'セーター２',
      brand: 'BARNI VARNO',
      category: 'ジャケット',
      price: 64900,
      stock: 0,
      size: 'L',
      color: '',
      soldOut: true,
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/e39e8db6e49fc17655abf2908467573c.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/b78a42408a4e2c63affa819831b0807d.jfif'
      ]
    },
    {
      id: 'item-7',
      name: 'BARNI VARNOジーンズ1',
      brand: 'BARNI VARNO',
      category: 'パンツ',
      stock: 1,
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/e8f1d20d6600a87a7c3629d465d8d001.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/c2c5b02aebe7bfd718e5e15bf6bfd91d.jfif'
      ]
    },
    {
      id: 'item-8',
      name: 'BARNI VARNOジーンズ2',
      brand: 'BARNI VARNO',
      category: 'パンツ',
      stock: 3,
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/7525e2e7b3fa46227da2fc861b028142.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/6775cf93b875c6c6a825fb36624a6fb1.jfif'
      ]
    },
    {
      id: 'item-9',
      name: 'トレーナー１',
      brand: 'BARNI VARNO',
      category: 'Tシャツ',
      price: 51700,
      stock: 1,
      size: 'L',
      color: 'ブラック',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/901392acda3d306a1e5cf4b1dea88b48.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/b07b7a7a6cdbe76c8dfa04eb8b9a0b0b.jfif'
      ]
    },
    {
      id: 'P04L',
      name: 'PANDIESTAジャンパー 1',
      brand: 'PANDIESTA',
      category: 'ジャケット',
      price: 17500,
      originalPrice: 19580,
      stock: 1,
      size: 'L',
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/89069ed24c90d81683f3c854c0f930c2.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/16f7f09cd314a998cc5f844d0927a0b4.jfif'
      ]
    },
    {
      id: 'P04XL',
      name: 'PANDIESTAジャンパー 2',
      brand: 'PANDIESTA',
      category: 'ジャケット',
      price: 17500,
      originalPrice: 19580,
      stock: 1,
      size: 'XL',
      color: '',
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/89069ed24c90d81683f3c854c0f930c2.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/16f7f09cd314a998cc5f844d0927a0b4.jfif'
      ]
    },
    {
      id: 'P05',
      name: 'PANDIESTAジャンパー 3',
      brand: 'PANDIESTA',
      category: 'ジャケット',
      price: 17500,
      originalPrice: 19580,
      stock: 0,
      size: 'M',
      color: '',
      soldOut: true,
      images: [
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/8f58a6f65d4bc83dbbc6dca29fe8155e.jfif',
        'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/bb5cbfabea3ae34cc62af6adddda14cc.jfif'
      ]
    }
  ];

  // フィルタリング機能を追加
  const filteredItems = useMemo(() => {
    return inventoryItems.filter(item => {
      const brandMatch = selectedBrand === '全て' || item.brand === selectedBrand;
      const categoryMatch = selectedCategory === '全て' || item.category === selectedCategory;
      return brandMatch && categoryMatch;
    });
  }, [selectedBrand, selectedCategory]);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "紳士服のミッキー 在庫一覧",
    "description": "PANDIESTA、SINACOVA、BARNI VARNOの在庫商品一覧",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/inventory`,
    "numberOfItems": inventoryItems.length,
    "itemListElement": inventoryItems.map((item, index) => ({
      "@type": "Product",
      "position": index + 1,
      "name": item.name,
      "brand": {
        "@type": "Brand",
        "name": item.brand
      },
      "category": item.category,
      "offers": {
        "@type": "Offer",
        "price": item.price || 0,
        "priceCurrency": "JPY",
        "availability": item.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        "seller": {
          "@type": "Organization",
          "name": "紳士服のミッキー"
        }
      },
      "image": item.images ? item.images[0] : ''
    }))
  };

  const getStockStatus = (stock: number) => {
    if (stock === 0) return { status: '売り切れ', color: 'bg-red-500' };
    if (stock <= 5) return { status: '残りわずか', color: 'bg-orange-500' };
    return { status: '在庫あり', color: 'bg-green-500' };
  };

  const handleImageClick = useCallback((itemId: string, totalImages: number) => {
    setItemImageIndexes(prev => ({
      ...prev,
      [itemId]: ((prev[itemId] || 0) + 1) % totalImages
    }));
  }, []);

  const openModal = useCallback((item: any) => {
    setSelectedItem(item);
    setCurrentImageIndex(0);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const handleItemClick = useCallback((item: any) => {
    openModal(item);
  }, [openModal]);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setSelectedItem(null);
    setCurrentImageIndex(0);
    document.body.style.overflow = 'unset';
  }, []);

  const nextImage = useCallback(() => {
    if (selectedItem && selectedItem.images) {
      setCurrentImageIndex((prev) => (prev + 1) % selectedItem.images.length);
    }
  }, [selectedItem]);

  const prevImage = useCallback(() => {
    if (selectedItem && selectedItem.images) {
      setCurrentImageIndex((prev) => (prev - 1 + selectedItem.images.length) % selectedItem.images.length);
    }
  }, [selectedItem]);

  const handleBrandFilter = useCallback((brand: string) => {
    setSelectedBrand(brand);
    // ブランドフィルター適用後、ページトップにスクロール
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleContactClick = useCallback((item?: any) => {
    // モーダルが開いている場合は閉じる
    if (showModal) {
      closeModal();
    }
    
    // 商品情報をURLパラメータとして渡してお問い合わせページに遷移
    const params = new URLSearchParams();
    if (item) {
      params.set('product', item.name);
      params.set('productId', item.id);
      params.set('brand', item.brand);
      if (item.price) {
        params.set('price', item.price.toString());
      }
    }
    navigate(`/contact?${params.toString()}`);
  }, [showModal, closeModal, navigate]);

  const handleStoreInfoClick = useCallback(() => {
    navigate('/store');
  }, [navigate]);

  // モーダルのクリーンアップ
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50">
      <SEOHead
        title="在庫一覧 - 紳士服のミッキー | PANDIESTA・SINACOVA・BARNI VARNO"
        description="紳士服のミッキーの在庫商品一覧。PANDIESTA、SINACOVA、BARNI VARNOの最新在庫状況をリアルタイムでご確認いただけます。"
        keywords="在庫一覧,PANDIESTA,SINACOVA,BARNI VARNO,メンズファッション,ジャケット,パンツ,Tシャツ"
        ogTitle="在庫一覧 - 紳士服のミッキー"
        ogDescription="PANDIESTA、SINACOVA、BARNI VARNOの在庫商品をリアルタイムでご確認いただけます。"
        ogImage="https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/f9313bb74139904003851b9e5334bc25.jfif"
        structuredData={structuredData}
      />
      <Header />
      
      {/* ヒーローセクション */}
      <section className="py-20 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-bold mb-6">
            在庫一覧
          </h1>
          <p className="text-2xl max-w-3xl mx-auto">
            現在店舗で取り扱っている商品の在庫状況を<br />
            リアルタイムでご確認いただけます。
          </p>
        </div>
      </section>

      {/* フィルターセクション */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* ブランドフィルター */}
              <div>
                <h3 className="text-lg font-semibold mb-4 text-gray-800">ブランド</h3>
                <div className="flex flex-wrap gap-2">
                  {brands.map((brand) => (
                    <button
                      key={brand}
                      onClick={() => handleBrandFilter(brand)}
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                        selectedBrand === brand
                          ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      {brand}
                    </button>
                  ))}
                </div>
              </div>

              {/* カテゴリーフィルター */}
              <div>
                <h3 className="text-lg font-semibold mb-4 text-gray-800">カテゴリー</h3>
                <div className="flex flex-wrap gap-2">
                  {categories.map((category) => (
                    <button
                      key={category}
                      onClick={() => setSelectedCategory(category)}
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                        selectedCategory === category
                          ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 在庫一覧 */}
      <section className="py-12 bg-gradient-to-r from-purple-100 via-pink-100 to-orange-100">
        <div className="container mx-auto px-4">
          <div className="mb-8 text-center">
            <p className="text-lg text-gray-600">
              検索結果: {filteredItems.length}件の商品が見つかりました
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-product-shop>
            {filteredItems.map((item) => {
              const stockInfo = getStockStatus(item.stock);
              const currentImageIdx = itemImageIndexes[item.id] || 0;
              const hasMultipleImages = item.images && item.images.length > 1;
              
              return (
                <div key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="relative">
                    <img 
                      src={item.images ? item.images[currentImageIdx] : ''}
                      alt={item.name}
                      className="w-full h-64 object-cover cursor-pointer"
                      onClick={() => {
                        if (hasMultipleImages) {
                          handleImageClick(item.id, item.images.length);
                        } else {
                          handleItemClick(item);
                        }
                      }}
                    />
                    {hasMultipleImages && (
                      <div className="absolute bottom-3 left-3 flex space-x-1">
                        {item.images.map((_, imgIndex) => (
                          <div
                            key={imgIndex}
                            className={`w-2 h-2 rounded-full cursor-pointer ${
                              imgIndex === currentImageIdx ? 'bg-white' : 'bg-white/50'
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              setItemImageIndexes(prev => ({
                                ...prev,
                                [item.id]: imgIndex
                              }));
                            }}
                          />
                        ))}
                      </div>
                    )}

                    <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-white text-xs font-semibold ${stockInfo.color}`}>
                      {stockInfo.status}
                    </div>
                    {item.id && (
                      <div className="absolute top-3 left-3 bg-black/70 text-white px-2 py-1 rounded text-xs font-medium">
                        {item.id}
                      </div>
                    )}
                    {(item as any).soldOut && (
                      <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
                        <div className="bg-red-600 text-white px-8 py-4 rounded-lg transform -rotate-12 text-2xl font-bold shadow-2xl border-4 border-white">
                          Sold Out
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="p-6">
                    <div className="mb-2">
                      <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Arial, sans-serif' }}>
                        {item.brand}
                      </span>
                    </div>
                    
                    <h3 className="text-lg font-bold text-gray-800 mb-2 line-clamp-2">
                      {item.name}
                    </h3>

                    <div className="space-y-2 mb-4 text-sm text-gray-600">
                      {item.color && (
                        <div className="flex items-center">
                          <i className="ri-palette-line mr-2 text-purple-500"></i>
                          <span>{item.color}</span>
                        </div>
                      )}
                      {item.size && (
                        <div className="flex items-center">
                          <i className="ri-ruler-line mr-2 text-purple-500"></i>
                          <span>{item.size}</span>
                        </div>
                      )}
                      <div className="flex items-center">
                        <i className="ri-archive-line mr-2 text-purple-500"></i>
                        <span>在庫: {item.stock}点</span>
                      </div>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <div className="flex flex-col">
                        {item.originalPrice && (
                          <div className="text-lg text-gray-500 relative mb-1">
                            <span className="relative inline-block">
                              ¥{item.originalPrice.toLocaleString()}<span className="text-xs">（税込）</span>
                              <span className="absolute left-0 right-0 top-1/2 h-0.5 bg-red-500 transform -translate-y-0.5 rotate-12"></span>
                            </span>
                          </div>
                        )}
                        {item.price ? (
                          <div className="text-2xl font-bold text-gray-800">
                            ¥{item.price.toLocaleString()}<span className="text-sm">（税込）</span>
                          </div>
                        ) : (
                          <div className="text-lg font-bold text-gray-800">
                            お問い合わせください
                          </div>
                        )}
                      </div>

                      <Button 
                        size="sm" 
                        className="whitespace-nowrap"
                        disabled={item.stock === 0}
                        onClick={(e) => {
                          e.stopPropagation();
                          openModal(item);
                        }}
                      >
                        <i className="ri-eye-line mr-1"></i>
                        詳細
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {filteredItems.length === 0 && (
            <div className="text-center py-20">
              <div className="w-24 h-24 mx-auto mb-6 bg-gray-200 rounded-full flex items-center justify-center">
                <i className="ri-search-line text-4xl text-gray-400"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">商品が見つかりませんでした</h3>
              <p className="text-gray-600 mb-6">別のフィルター条件をお試しください。</p>
              <Button onClick={() => {
                setSelectedBrand('全て');
                setSelectedCategory('全て');
              }} className="whitespace-nowrap">
                フィルターをリセット
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* 商品詳細モーダル */}
      {showModal && selectedItem && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 z-10 w-10 h-10 bg-black/50 text-white rounded-full flex items-center justify-center hover:bg-black/70 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
                {/* 画像エリア */}
                <div className="relative">
                  <img
                    src={selectedItem.images ? selectedItem.images[currentImageIndex] : ''}
                    alt={selectedItem.name}
                    className="w-full h-96 object-cover rounded-lg"
                  />
                  
                  {selectedItem.images && selectedItem.images.length > 1 && (
                    <>
                      <button
                        onClick={prevImage}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/50 text-white rounded-full flex items-center justify-center hover:bg-black/70 transition-colors cursor-pointer"
                      >
                        <i className="ri-arrow-left-line"></i>
                      </button>
                      <button
                        onClick={nextImage}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/50 text-white rounded-full flex items-center justify-center hover:bg-black/70 transition-colors cursor-pointer"
                      >
                        <i className="ri-arrow-right-line"></i>
                      </button>
                      
                      <div className="flex justify-center mt-4 space-x-2">
                        {selectedItem.images.map((_, index) => (
                          <button
                            key={index}
                            onClick={() => setCurrentImageIndex(index)}
                            className={`w-3 h-3 rounded-full cursor-pointer ${
                              index === currentImageIndex ? 'bg-purple-500' : 'bg-gray-300'
                            }`}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
                
                {/* 商品情報エリア */}
                <div>
                  <div className="mb-4">
                    <span className="text-sm font-medium text-purple-600 uppercase tracking-wider" style={{ fontFamily: 'Arial, sans-serif' }}>
                      {selectedItem.brand}
                    </span>
                  </div>
                  
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">
                    {selectedItem.name}
                  </h2>
                  
                  <div className="flex flex-col mb-6">
                    {selectedItem.originalPrice && (
                      <div className="text-2xl text-gray-500 relative mb-2">
                        <span className="relative inline-block">
                          ¥{selectedItem.originalPrice.toLocaleString()}<span className="text-base">（税込）</span>
                          <span className="absolute left-0 right-0 top-1/2 h-0.5 bg-red-500 transform -translate-y-0.5 rotate-12"></span>
                        </span>
                      </div>
                    )}
                    {selectedItem.price ? (
                      <div className="text-4xl font-bold text-purple-600">
                        ¥{selectedItem.price.toLocaleString()}<span className="text-lg">（税込）</span>
                      </div>
                    ) : (
                      <div className="text-2xl font-bold text-purple-600">
                        お問い合わせください
                      </div>
                    )}
                  </div>
                  
                  <div className="space-y-4 mb-6">
                    {selectedItem.color && (
                      <div className="flex items-center">
                        <i className="ri-palette-line mr-3 text-purple-500 text-lg"></i>
                        <span className="text-gray-700">カラー: {selectedItem.color}</span>
                      </div>
                    )}
                    {selectedItem.size && (
                      <div className="flex items-center">
                        <i className="ri-ruler-line mr-3 text-purple-500 text-lg"></i>
                        <span className="text-gray-700">サイズ: {selectedItem.size}</span>
                      </div>
                    )}
                    <div className="flex items-center">
                      <i className="ri-archive-line mr-3 text-purple-500 text-lg"></i>
                      <span className="text-gray-700">在庫: {selectedItem.stock}点</span>
                    </div>
                  </div>
                  
                  <div className="flex space-x-4">
                    <button 
                      onClick={() => handleContactClick(selectedItem)}
                      className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700 shadow-lg hover:shadow-xl px-8 py-4 text-lg flex-1"
                      disabled={selectedItem.stock === 0}
                    >
                      <i className="ri-phone-line mr-2"></i>
                      お問い合わせ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 在庫状況説明 */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                在庫状況について
              </h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-2xl">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">在庫あり</h3>
                <p className="text-gray-600">
                  十分な在庫がございます。<br />
                  安心してご来店ください。
                </p>
              </div>
              
              <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-alarm-warning-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">残りわずか</h3>
                <p className="text-gray-600">
                  在庫が少くなっています。<br />
                  お早めにご来店ください。
                </p>
              </div>
              
              <div className="text-center p-6 bg-gradient-to-br from-red-50 to-red-100 rounded-2xl">
                <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-close-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">売り切れ</h3>
                <p className="text-gray-600">
                  申し訳ございません。<br />
                  現在在庫切れとなっています。
                </p>
              </div>
            </div>
            
            <div className="mt-12 p-6 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-information-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">在庫情報について</h3>
                  <p className="text-gray-700 leading-relaxed">
                    在庫情報は定期的に更新しておりますが、店舗での販売状況により実際の在庫と異なる場合がございます。
                    ご来店前にお電話（0284-21-3298）でお問い合わせいただくことをおすすめいたします。
                    また、サイズや色違いの商品もお取り寄せ可能な場合がありますので、お気軽にご相談ください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTAセクション */}
      <section className="py-20 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-5xl font-bold mb-6">
            気になる商品はございましたか？
          </h2>
          <p className="text-2xl mb-8 max-w-3xl mx-auto">
            実際に商品を手に取ってご確認いただけます。<br />
            専門スタッフがあなたにぴったりの一着をご提案いたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => handleContactClick()}
              className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap border-2 border-white text-white hover:from-purple-700 hover:to-pink-700 shadow-lg hover:shadow-xl px-10 py-5"
            >
              <i className="ri-phone-line mr-2"></i>
              電話で問い合わせ
            </button>
            <button 
              onClick={handleStoreInfoClick}
              className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap border-2 border-white text-white hover:from-purple-700 hover:to-pink-700 shadow-lg hover:shadow-xl px-10 py-5"
            >
              <i className="ri-map-pin-line mr-2"></i>
              店舗情報を見る
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
